import React from "react";
import CardRCSDashboard from "./CardRCSDashboard";
import PieRCSDashboard from "./PieRCSDashboard";
import GraphRCSDashboard from "./LinealRCSDashboard";
import RCSPartners from "./RCSPartners";
import RCSProviders from "./RCSProviders";
import RCSPending from "./RCSPending";
import { useRCSDashboardSummary } from "../hooks/useRCSDashboardSummary";
import { useGraphByHourRCS } from "../hooks/useGraphByHourRCS";
import { useRCSByCarrier } from "../hooks/useRCSByCarrier";
import { useRCSByPartner } from "../hooks/useRCSByPartner";
import { useRCSProcessingMessages } from "../hooks/useRCSProcessingMessages";
import { useRCSHealth } from "../hooks/useRCSHealth";
import RCSHealthApi from "./RCSHealthApi";

const _RCSDashboard = () => {
  const {
    data,
    isPending: loading,
    refetch: refetchCards,
    isFetching,
  } = useRCSDashboardSummary();
  const { refetch: refetchGraphByHours } = useGraphByHourRCS();
  const { refetch: refetchPartners } = useRCSByPartner();
  const { refetch: refetchProviders } = useRCSByCarrier();
  const { refetch: refetchPending } = useRCSProcessingMessages();
  const { refetch: refetchHealth } = useRCSHealth();

  const reload = async () => {
    await Promise.all([
      refetchCards(),
      refetchGraphByHours(),
      refetchPartners(),
      refetchProviders(),
      refetchPending(),
      refetchHealth(),
    ]);
  };
  return (
    <div className="flex flex-col space-y-4">
      <div className="flex justify-end">
        <button
          className="flex items-center text-gray-600 bg-gray-200 px-4 py-2 rounded hover:bg-gray-300 border-none disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={reload}
        >
          <span className="material-symbols-outlined">sync</span>
          <span>Actualizar</span>
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-6">
        <CardRCSDashboard data={data} loading={loading || isFetching} />
        <RCSHealthApi />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4 md:gap-6">
        <div className="col-span-1 md:col-span-2 lg:col-span-3">
          <PieRCSDashboard
            data={{
              i_campaigns: data?.i_campaigns ?? 0,
              i_api: data?.i_api ?? 0,
            }}
            loading={loading || isFetching}
          />
        </div>
        <div className="col-span-1 md:col-span-2 lg:col-span-9">
          <GraphRCSDashboard />
        </div>
      </div>

      <div className="Divider"></div>

      <h4 className="text-lg font-bold"> Detalles</h4>

      <div className="grid grid-cols-1 md:grid-cols-2  gap-4 md:gap-6">
        {/** Mensajes por procesar */}
        <RCSProviders />
        {/** Mensajes por parnter */}
        <RCSPending />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
        {/** Mensajes por procesar API */}
        <RCSPartners />
      </div>
    </div>
  );
};

export default _RCSDashboard;
